// extracted by mini-css-extract-plugin
export default {"modal-list":"ModalCollectOrder_modal-list__P-Z-v","modal-item":"ModalCollectOrder_modal-item__VyIqs"};